<div [formGroup]="form" class="form-group" enctype="multipart/form-data">
	<!-- LABEL -->
	<p *ngIf="question.QuestionText" [ngClass]="{'invalid-label': NIGOQuestion}">
		<span [innerHTML]="question.QuestionTextAlt || question.QuestionText"></span>&nbsp;<span class="text-nowrap"><sup *ngIf="(!question.IsOptional) && (question.QuestionType !== 'Compound')" class="asterisk">*</sup>
		<popover *ngIf="question.ToolTip" [content]="question.ToolTip"></popover></span>
	</p>

	    <div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULFundAllocationTotal' && questionService.getFinalTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getFinalTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getFinalTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getFinalTotal() !== 100">(Needs to be 100%)</small>
	    </div>
	    <div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULSegmentFromBCIATotal' && questionService.getVulSegmentProceedsAllocationTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getVulSegmentProceedsAllocationTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getVulSegmentProceedsAllocationTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getVulSegmentProceedsAllocationTotal() !== 100">(Needs to be 100%)</small>
	    </div>

	    <div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULSegmentFromBHPCIATotal' && questionService.getBaseHighParCappedIndexedAccountTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getBaseHighParCappedIndexedAccountTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getBaseHighParCappedIndexedAccountTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getBaseHighParCappedIndexedAccountTotal() !== 100">(Needs to be 100%)</small>
	    </div>

		<!-- JIRA: 3476 Begin -->
		<div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULSegmentFromBCTYIATotal' && questionService.getBaseCappedTwoYearIndexedAccountTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getBaseCappedTwoYearIndexedAccountTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getBaseCappedTwoYearIndexedAccountTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getBaseCappedTwoYearIndexedAccountTotal() !== 100">(Needs to be 100%)</small>
	    </div>

		<div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULSegmentFromHCIATotal' && questionService.getHighCappedIndexedAccountTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getHighCappedIndexedAccountTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getHighCappedIndexedAccountTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getHighCappedIndexedAccountTotal() !== 100">(Needs to be 100%)</small>
	    </div>
		<!-- JIRA: 3476 End -->

	    <div class="progress-bar-container block" *ngIf="question.QuestionName == 'VULAllocationMonthlyChargesTotal' && questionService.getAllocationofMonthlyChargesTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getAllocationofMonthlyChargesTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getAllocationofMonthlyChargesTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getAllocationofMonthlyChargesTotal() !== 100">(Needs to be 100%)</small>
	    </div>

	    <div class="progress-bar-container block" *ngIf="question.QuestionName == 'AccountBalancerTotal' && questionService.getAccountBalancerTotal() > 0">
	        <mat-progress-bar mode="determinate" [value]="questionService.getAccountBalancerTotal()"></mat-progress-bar>
	        <p style="left:25px; line-height:1.5rem" class="percentage">{{ questionService.getAccountBalancerTotal() }}%</p>
	        <small class="error-message" *ngIf="questionService.getAccountBalancerTotal() !== 100">(Needs to be 100%)</small>
		</div>

	<!-- DEFAULT INPUT -->
	<ng-container *ngIf="!showCustomForm;else customForms" [ngSwitch]="question.controlType">
		<!-- text input -->
		<div class="demo-overlay" *ngIf="demoDisabled"></div>
		<ng-container *ngSwitchCase="'textbox'">
			<div [ngClass]="{'ssn-wrapper': isSSN, 'input-group':isPercent}" >
				<label for="{{question.QuestionName}}" class="visually-hidden">{{ question.QuestionName }}</label>
				<input id="{{question.QuestionName}}" [cleave]="mask" [maxlength]="maxInputLength" class="form-control" [formControlName]="question.QuestionName" (keypress)="isSSN ? ssnType='text' : null" (blur)="isSSN ? ssnType='password' : null" [id]="question.QuestionName + multiIndex" [type]="isSSN ? ssnType : question.inputType" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'custom-validator': hasCustomValidator, 'disabled': demoDisabled}">
				<ng-container *ngIf="isSSN"><i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i></ng-container>
				<div *ngIf="isPercent" class="input-group-append">
					<span class="input-group-text">%</span>
				</div>
			</div>
		</ng-container>

		<!-- dropdown -->
		<div class="select-wrapper" *ngSwitchCase="'dropdown'">
			<label for="question.QuestionName + multiIndex" class="visually-hidden">{{ question.QuestionName }}</label>
		<!--	<label for="{{question.QuestionName + multiIndex}}" class="visually-hidden">{{ question.QuestionName }}</label> -->
			<select class="form-control" [id]="question.QuestionName + multiIndex" [formControlName]="question.QuestionName" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'custom-validator': hasCustomValidator, 'disabled': demoDisabled}">
				<option [ngValue]="null" label="Select one" selected="selected"></option>
				<div class="demo-overlay" *ngIf="demoDisabled"></div>
				<ng-container *ngFor="let opt of question.QuestionOptions">
					<option [value]="opt.key" [innerHtml]="opt.OptionAltText || opt.value"
						*ngIf="!opt.ConditionalClause || showConditionalOption(opt.ConditionalClause)"></option>
				</ng-container>
			</select>
		</div>

		<!-- autocomplete -->
		<autocomplete *ngSwitchCase="'autocomplete'" [options]="question.QuestionOptions" aria-label="auto-complete form component" [formControlName]="question.QuestionName" [parentForm]="form" [id]="question.QuestionName + multiIndex" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'custom-validator': hasCustomValidator, 'disabled': demoDisabled}" [isEditable]="isEditable"></autocomplete>

		<!-- radio -->
		<mat-radio-group class="form-control" [formControlName]="question.QuestionName" *ngSwitchCase="'radio'"
			[id]="question.QuestionName + multiIndex">
			<div class="demo-overlay" *ngIf="demoDisabled"></div>
			<ng-container *ngFor="let opt of question.QuestionOptions">
				<mat-radio-button [value]="opt.key"
					*ngIf="!opt.ConditionalClause || showConditionalOption(opt.ConditionalClause)" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'disabled': demoDisabled}">
					{{ opt.OptionAltText || opt.value }}
				</mat-radio-button>
			</ng-container>
		</mat-radio-group>

		<!--  yes/no -->
		<div class="button-wrapper button-toggle-wrapper" *ngSwitchCase="'yesno'">
			<div class="demo-overlay" *ngIf="demoDisabled"></div>
			<mat-button-toggle-group [formControlName]="question.QuestionName" [id]="question.QuestionName + multiIndex">
				<mat-button-toggle *ngFor="let opt of question.QuestionOptions" value="{{ opt.key }}"
					[id]="question.QuestionName + opt.value" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'disabled': demoDisabled}">
					{{ opt.value }}
				</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
		
		<!-- checkbox -->
		<div class="checkbox-wrapper" [formArrayName]="question.QuestionName" *ngSwitchCase="'checkbox'" [id]="question.QuestionName + multiIndex" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'disabled': demoDisabled}">
			<div class="demo-overlay" *ngIf="demoDisabled"></div>
			<ng-container *ngFor="let opt of question.QuestionOptions; let i = index">
				<mat-checkbox color="green" [formControlName]="i"
					*ngIf="!opt.ConditionalClause || showConditionalOption(opt.ConditionalClause, question.QuestionName, i)"
					(change)="checkboxChange(opt, i, $event)" [ngClass]="{'solo': (question.QuestionOptions.length < 2)}" tabindex="{{blockIndex}}">
					<span class="label" [innerHtml]="opt.OptionAltText || opt.value"></span>
					<span *ngIf="opt.ToolTip" class="description" [innerHtml]="opt.ToolTip"></span>
				</mat-checkbox>
			</ng-container>
		</div>

		<!-- Label -->
		<ng-container *ngSwitchCase="'label'">
			<p [innerHtml]="question.QuestionTextAlt || question.QuestionText"></p>
		</ng-container>

		<!-- datepicker -->
		<div class="datepicker-wrapper" *ngSwitchCase="'datepicker'">
			<ng-container [ngSwitch]="question.QuestionType">
				<!-- MonthYear: MM/YYYY -->
				<ng-container *ngSwitchCase="'MonthYear'">
					<label for="{{question.QuestionName}}" class="visually-hidden">{{ question.QuestionName }}</label>
					<input id="{{question.QuestionName}}" [maxlength]="maxInputLength" [textMask]="{mask: mask, guide: false}" class="form-control"
						[formControlName]="question.QuestionName" placeholder="mm/yyyy" [id]="question.QuestionName + multiIndex"
						type="text" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'custom-validator': hasCustomValidator, 'disabled': demoDisabled}">
				</ng-container>

				<!-- Default: MM/DD/YYYY -->
				<ng-container *ngSwitchDefault>
					<label for="{{question.QuestionName}}" class="visually-hidden">{{ question.QuestionName }}</label>
					<input id="{{question.QuestionName}}" [maxlength]="maxInputLength" [textMask]="{mask: mask, guide: false}" class="form-control"
						[formControlName]="question.QuestionName" placeholder="mm/dd/yyyy" [id]="question.QuestionName + multiIndex"
						type="text" tabindex="0" [ngClass]="{'input-required': !question.IsOptional && isEditable && !demoDisabled, 'custom-validator': hasCustomValidator, 'disabled': demoDisabled}">
				</ng-container>
			</ng-container>
		</div>

		<!-- validation message -->
		<error-messages [form]="form" [field]="question.QuestionName"></error-messages>

	</ng-container><!-- /DEFAULT INPUT -->

	<!-- CUSTOM FORMS -->
	<ng-template #customForms>
		<!-- handle specific types -->
		<div class="demo-overlay" *ngIf="demoDisabled"></div>
		<ng-container [ngSwitch]="question.QuestionType">
			<!-- name -->
			<name-form [formGroupName]="question.QuestionName" [parent]="form" *ngSwitchCase="'Name'" [isRequired]="!question.IsOptional"></name-form>

			<!-- address -->
			<address-form [formGroupName]="question.QuestionName" [parent]="form" *ngSwitchCase="'Address'" [isRequired]="!question.IsOptional"></address-form>

			<!-- physician -->
			<physician-form [formGroupName]="question.QuestionName" [parent]="form" *ngSwitchCase="'Physician'" [isRequired]="!question.IsOptional"></physician-form>

			<!-- length -->
			<length-form [formGroupName]="question.QuestionName" [parent]="form" *ngSwitchCase="'Length'" [isRequired]="!question.IsOptional"></length-form>

			<!-- blood pressure -->
			<blood-pressure-form [formGroupName]="question.QuestionName" [parent]="form" *ngSwitchCase="'BloodPressure'" [isRequired]="!question.IsOptional"></blood-pressure-form>

			<!-- filepicker -->
			<file-upload [formGroupName]="question.QuestionName" [parent]="form" [question]="question" *ngSwitchCase="'File'" [isRequired]="!question.IsOptional" [isEditable]="isEditable"></file-upload>

			<!-- validation message -->
			<error-messages [form]="form" [field]="question.QuestionName"></error-messages>
		</ng-container><!-- /DEFAULT INPUT -->

		<!-- IUL percent tables -->
		<ng-container *ngIf="question.QuestionName === 'IULPremPaymentAllocation' || question.QuestionName === 'IULFixedAcctAlloc' || question.QuestionName === 'IULProceedsAllocToCompound'">
			<percentage-table [formGroupName]="question.QuestionName" [parent]="form" [childQuestions]="getChildQuestions(question)" [isRequired]="!question.IsOptional"></percentage-table>
		</ng-container>

		<!-- VUL percent tables-->
		<ng-container *ngIf="question.QuestionName === 'VULFundAggressiveOptionsCompound' ||
							 question.QuestionName === 'VULFundGrowthOptionsCompound' ||
							 question.QuestionName === 'VULFundIncomeOptionsCompound' ||
							 question.QuestionName === 'VULFundGrowthIncomeOptionsCompound' ||
							 question.QuestionName === 'VULFundIndexedOptionsCompound' ||
							 question.QuestionName === 'VULFundLifestyleOptionsCompound' ||
							 question.QuestionName === 'VULFundETFOptionsCompound' ||
							 question.QuestionName === 'VULFundManagedVolatilityOptionsCompound' ||
							 question.QuestionName === 'VULFundETFOptionsCompound' ||
							 question.QuestionName === 'VULFundConservativeOptionsCompound'">
			<vul-percentage-table [parent]="form" [childQuestions]="getChildQuestions(question)" [isRequired]="!question.IsOptional"></vul-percentage-table>
		</ng-container>

		<!-- handle MultipleResponse -->
		<ng-container *ngIf="isMultipleResponse">

			<!-- switch question name -->
			<ng-container [ngSwitch]="question.QuestionName">

				<!-- Medical Conditions -->
				<div class="row" [formArrayName]="question.QuestionName" *ngSwitchCase="'MedicalConditionDetails'">
					<ng-container>
						<div class="col-12" style="margin-bottom: 50px">
							<medical-conditions class="custom-form" *ngFor="let comp of form.get(question.QuestionName).controls; let i=index"
								[formGroupName]="i" [parent]="form" [childQuestions]="medicalConditionQuestions"></medical-conditions>
						</div>
					</ng-container>
				</div>

				<div [formArrayName]="question.QuestionName" *ngSwitchDefault>
					<multiple-response class="custom-form" *ngFor="let comp of form.get(question.QuestionName).controls; let i=index"
						[formGroupName]="i" [parent]="form" [childQuestions]="childQuestions"
						(remove)="removeDetails($event, question.QuestionName)" [isEditable]="isEditable" [toggleOpenFields]="toggleOpenFields"></multiple-response>
					<div class="button-wrapper">
						<button id="{{question.QuestionName}}" class="btn btn-add" (click)="addDetails(question.QuestionName)" type="button" tabindex="0" [disabled]="disableMultipleReponseButton">
							<i class="fas fa-plus" aria-hidden="true"></i> ADD {{ buttonLabel }}
						</button>
					</div>
				</div>
			</ng-container><!-- /switch question name -->
		</ng-container><!-- /handle MultipleResponse -->
	</ng-template><!-- /CUSTOM FORMS -->
</div>